import React from 'react';
import { FaCheck, FaTimes, FaClock, FaStar, FaEye } from 'react-icons/fa';
import { Tabs, Tab } from './Tabs';
import TeamName from './TeamName';

const formatSpread = (spread) => (spread > 0 ? `+${spread}` : `${spread}`);

const PickMatchup = ({ game, userPick }) => {
  const awaySelected = userPick.pick === 'away';
  const homeSelected = userPick.pick === 'home';

  return (
    <div className="flex flex-wrap items-center gap-x-1.5 gap-y-1 min-w-0">
      <TeamName
        size="sm"
        name={game.awayTeam}
        logo={game.awayLogo}
        className={awaySelected ? 'font-semibold text-accent' : 'text-gray-300'}
      />
      <span className={`text-xs ${awaySelected ? 'text-accent' : 'text-gray-400'}`}>
        {formatSpread(game.awaySpread)}
      </span>
      <span className="text-gray-500 text-xs">@</span>
      <TeamName
        size="sm"
        name={game.homeTeam}
        logo={game.homeLogo}
        className={homeSelected ? 'font-semibold text-accent' : 'text-gray-300'}
      />
      <span className={`text-xs ${homeSelected ? 'text-accent' : 'text-gray-400'}`}>
        {formatSpread(game.homeSpread)}
      </span>
      {userPick.triplePlay ? <FaStar className="text-yellow-400 text-xs ml-0.5" title="Triple Play" /> : null}
    </div>
  );
};

const UserDetails = ({ weeks, score, gamesByWeek, userPicks, isAdmin, currentUser }) => {
  const getWeeklyTotal = (userScores, week) => {
    const games = gamesByWeek[week] || [];
    return games.reduce((total, game) => {
      const gameId = game.id;
      return total + (userScores[gameId] || 0);
    }, 0);
  };

  return (
    <tr className="bg-gray-800">
      <td colSpan={weeks.length + 2} className="px-3 py-3">
        <Tabs highestWeek={1}>
          {weeks.map(week => (
            <Tab key={week} label={`Week ${week}`}>
              <ul className="divide-y divide-gray-700">
                {gamesByWeek[week].map(game => {
                  const userPick = userPicks[score.userId] && userPicks[score.userId][game.id];
                  const isCorrectPick = game.winner === 'push' || (userPick?.pick === game?.winner);
                  const canViewPick = isAdmin || game.locked || score.userId === currentUser?.uid;
                  return (
                    <li key={game.id} className="flex items-start gap-2 py-2 first:pt-0 last:pb-0">
                      {canViewPick ? (
                        <>
                          <span className="mt-0.5 w-4 flex-shrink-0">
                            {game.winner ? (
                              isCorrectPick ? <FaCheck className="text-green-500" /> : <FaTimes className="text-red-500" />
                            ) : (
                              <FaClock className="text-yellow-500" />
                            )}
                          </span>
                          {userPick ? (
                            <PickMatchup game={game} userPick={userPick} />
                          ) : (
                            <span className="text-sm text-gray-400">No pick</span>
                          )}
                        </>
                      ) : (
                        <>
                          <FaEye className="mt-0.5 text-yellow-500 flex-shrink-0" />
                          <span className="text-sm text-gray-400">Hidden until lock</span>
                        </>
                      )}
                    </li>
                  );
                })}
              </ul>
              <div className="mt-3 pt-3 border-t border-gray-700 text-sm">
                <strong>Weekly total: {getWeeklyTotal(score.weeklyScores, week)}</strong>
              </div>
            </Tab>
          ))}
        </Tabs>
      </td>
    </tr>
  );
};

export default UserDetails;
